export const screenSize = {
  xs: 375,
  sm: 744,
  md: 1199,
  lg: 1439,
  xl: 1599,
}
export type ScreenSizes = keyof typeof screenSize

export function asUseMediaQuery(size: ScreenSizes) {
  return `(max-width: ${screenSize[size]}px)`
}

export function mediaQuery(size: ScreenSizes) {
  return `@media only screen and (max-width: ${screenSize[size]}px)`
}
